import { render, staticRenderFns } from "./LmFileViewer.vue?vue&type=template&id=b2afc8c0"
import script from "./LmFileViewer.vue?vue&type=script&lang=js"
export * from "./LmFileViewer.vue?vue&type=script&lang=js"
import style0 from "./LmFileViewer.vue?vue&type=style&index=0&id=b2afc8c0&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports